export default __webpack_public_path__ + "static/media/bambu masaya1.5a6cf3a4.jpeg";